export default __webpack_public_path__ + "static/media/Reduced-Chair.e27f88d9.png";